/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum UserBankStatus {
    AVAILABLE = 'Available',
    IN_PROGRESS = 'InProgress',
    REQUESTED = 'Requested',
    NOT_POSSIBLE = 'NotPossible',
}